import { defineStore } from 'pinia';
import { Config, ConfigService, IConfig, IConfigService, UpdateGeneralConfigOptions } from '@posx/core';
import { ServicesBuilder } from '@/utils/setup.utils';

export const configStore = defineStore('config', {
  state: () => ({
    globalConfig: new Config(),
  }),
  actions: {
    async load() {
      const service = await ServicesBuilder.getInstance().getService<IConfigService>(ConfigService);
      service
        ?.liveQuery(() => service?.getMany({}, {}))
        .subscribe({
          next: (result) => {
            if (result.list.length > 0) {
              this.globalConfig = result.list[0]?.config;
            }
          },
          error: (err) => console.error('ConfigStore: liveQuery error', err),
        });
      if (this.globalConfig?.general) {
        this.globalConfig.general.company_name = 'from Config company';
      }
    },
    async updateGeneralConfig(payload: UpdateGeneralConfigOptions) {
      const service = await ServicesBuilder.getInstance().getService<IConfigService>(ConfigService);
      return service?.updateGeneralConfig(payload);
    },
    async updateConfig(key: keyof IConfig, payload: UpdateGeneralConfigOptions) {
      const service = await ServicesBuilder.getInstance().getService<IConfigService>(ConfigService);

      return service?.updateConfig(key, payload);
    },
  },
});
